import isRelative from 'is-relative-url';
import join from 'url-join';

const normalizeLink = (link?: string) => {
  if (link && isRelative(link)) {
    return join(link, '/');
  }
  return link;
};

export default normalizeLink;
